import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AdaAccessComponent } from './features/ada-access/ada-access.component';
import { AuthGuard } from './core/guard/utility.guard';
import { DigitalIdentityComponent } from './features/digital-identity/digital-identity.component';
import { LandingGuard } from './core/guard/landing.guard';
import { AppComponent } from './app.component';
import { GuideComponent } from './guide/guide.component';
import { DsoGuardComponent } from './features/dso-guard/dso-guard.component';
import { SecureBlockchainComponent } from './features/secure-blockchain/secure-blockchain.component';
import { InsightEgrcComponent } from './features/insight-egrc/insight-egrc.component';
import { ErrorPageComponent } from './shared/error-page/error-page.component';
import { SecureZoneComponent } from './features/security-zone/secure-zone.component';
import { SecureZoneAuthoringToolsComponent } from './features/security-zone/authoring-tools/secure-zone-authoring-tools.component';

import { DataProtectionAuthoringToolsComponent } from './features/data-protection/auth-tools/data-protection-authoring-tools/data-protection-authoring-tools.component';
import { AssetManagementAuthoringToolsComponent } from './features/asset-management/auth-tools/asset-management-authoring-tools/asset-management-authoring-tools.component';


export const router: Routes = [
  { path: '', redirectTo: 'products', pathMatch: 'full' },
  { path: 'products', component: HomeComponent, canActivate: [AuthGuard]},
  { path: 'guide', component: GuideComponent, canActivate: [AuthGuard]},
  {path: 'ada-access',component:AdaAccessComponent, canActivate: [AuthGuard] },
  {path: 'user-type', redirectTo: 'user-type/search', pathMatch: 'full'}, 
  {path: 'data-protection',component:DataProtectionAuthoringToolsComponent, canActivate: [AuthGuard]},
  {path: 'asset-management',component:AssetManagementAuthoringToolsComponent, canActivate: [AuthGuard]},
  {path: 'digital-identity',component:DigitalIdentityComponent, canActivate: [AuthGuard]},
  {path: 'secure-blockchain',component:SecureBlockchainComponent, canActivate: [AuthGuard]},
  // {path: 'dso-guard',component:DsoGuardComponent, canActivate: [AuthGuard]},
  {path: 'insight-egrc',component:InsightEgrcComponent, canActivate: [AuthGuard]},
  

  //   {
  //   path: 'error/:code',
  //   component: ErrorPageComponent
  // },
  // {
  //   path: '**',
  //   redirectTo: 'error/404'
  // },

];

export const routes = RouterModule.forRoot(router, { enableTracing: true });